import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileRequestComponent } from './file-request.component';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import {MatLegacyCheckboxModule as MatCheckboxModule} from '@angular/material/legacy-checkbox';
import {EmmaTooltipModule} from '../../base-components/emma-tooltip/emma-tooltip.module';

@NgModule({
  declarations: [
    FileRequestComponent
  ],
  imports: [
    CommonModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    EmmaTooltipModule,
  ],
  exports: [
    FileRequestComponent
  ]
})
export class FileRequestModule {}
